import React from 'react';
import {
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SettingsIcon from '@mui/icons-material/Settings';

export default function ConfigHorariosPanel({
  horariosPorDia = [],
  onOpenModal,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <AccessTimeIcon color="primary" />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            Quando o check-in é permitido
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Fora desses horários, os check-ins são automaticamente bloqueados.
          </Typography>
        </Box>
      </Box>

      <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Dia</strong></TableCell>
              <TableCell><strong>Intervalos permitidos</strong></TableCell>
              <TableCell align="right"><strong>Status</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {horariosPorDia.map((dia) => {
              const rowSx = dia.fechado
                ? { backgroundColor: '#f6f7f9' }
                : dia.hasExtras
                  ? { backgroundColor: '#fff0f3' }
                  : {};
              return (
                <TableRow key={dia.dia} sx={rowSx}>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      <Typography fontWeight="bold">{dia.label}</Typography>
                      {dia.hasExtras ? (
                        <Chip
                          label="Horário especial"
                          size="small"
                          sx={{ bgcolor: '#fff1f2', color: '#9f1239', fontWeight: 'bold' }}
                        />
                      ) : null}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {dia.fechado ? (
                      <Typography variant="body2" color="text.secondary">
                        Fechado
                      </Typography>
                    ) : (
                      <Box display="flex" flexWrap="wrap" gap={1}>
                        {dia.intervalos.map((intervalo, index) => (
                          <Box
                            key={`${dia.dia}-${index}`}
                            sx={{
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 1,
                              backgroundColor: '#f1f5f9',
                            }}
                          >
                            <Typography variant="body2" fontWeight="bold">
                              {intervalo.abre?.slice(0, 5)} - {intervalo.fecha?.slice(0, 5)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </TableCell>
                  <TableCell align="right">
                    {dia.fechado ? (
                      <Chip
                        label="Inativo"
                        size="small"
                        sx={{ bgcolor: '#e5e7eb', color: '#4b5563', fontWeight: 'bold' }}
                      />
                    ) : (
                      <Chip
                        label="Ativo"
                        size="small"
                        sx={{ bgcolor: '#ecfdf3', color: '#067647', fontWeight: 'bold' }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="caption" color="text.secondary" display="block" mt={2}>
        Dias com mais de um intervalo ficam marcados como horário especial.
      </Typography>

      <Box display="flex" alignItems="center" gap={2} mt={2} flexWrap="wrap">
        <Button
          variant="contained"
          onClick={onOpenModal}
          startIcon={<SettingsIcon />}
          data-tour="config-open-button"
          className="clube-primary-button"
        >
          Revisar configurações de check-in
        </Button>
        <Typography variant="caption" color="text.secondary">
          Qualquer mudança aqui afeta imediatamente os check-ins.
        </Typography>
      </Box>
    </Paper>
  );
}
